import { useContext } from 'react';
import { GoogleMapsContext } from '../contexts/GoogleMapsContext';

export function useGoogleMaps() {
  const value = useContext(GoogleMapsContext)
  return value
}